export default "__VITE_ASSET__3dc71981__"